export default function Error(){
    return <h1>Error Loading Details.<br/> Please try later.</h1>
}